/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesInfoNewsNews } from './FxIdWebFeaturesInfoNewsNews';
import {
    FxIdWebFeaturesInfoNewsNewsFromJSON,
    FxIdWebFeaturesInfoNewsNewsFromJSONTyped,
    FxIdWebFeaturesInfoNewsNewsToJSON,
    FxIdWebFeaturesInfoNewsNewsToJSONTyped,
} from './FxIdWebFeaturesInfoNewsNews';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesInfoNewsResponse
 */
export interface FxIdWebFeaturesInfoNewsResponse {
    /**
     * 
     * @type {Array<FxIdWebFeaturesInfoNewsNews>}
     * @memberof FxIdWebFeaturesInfoNewsResponse
     */
    News: Array<FxIdWebFeaturesInfoNewsNews>;
}

/**
 * Check if a given object implements the FxIdWebFeaturesInfoNewsResponse interface.
 */
export function instanceOfFxIdWebFeaturesInfoNewsResponse(value: object): value is FxIdWebFeaturesInfoNewsResponse {
    if (!('News' in value) || value['News'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesInfoNewsResponseFromJSON(json: any): FxIdWebFeaturesInfoNewsResponse {
    return FxIdWebFeaturesInfoNewsResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesInfoNewsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesInfoNewsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'News': ((json['News'] as Array<any>).map(FxIdWebFeaturesInfoNewsNewsFromJSON)),
    };
}

export function FxIdWebFeaturesInfoNewsResponseToJSON(json: any): FxIdWebFeaturesInfoNewsResponse {
    return FxIdWebFeaturesInfoNewsResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesInfoNewsResponseToJSONTyped(value?: FxIdWebFeaturesInfoNewsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'News': ((value['News'] as Array<any>).map(FxIdWebFeaturesInfoNewsNewsToJSON)),
    };
}

